import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { css } from '@linaria/core'
import { styled } from '@linaria/react'
import { Link } from '@tanstack/router'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import bgImage from '../../assets/login-bonus/login_bonus_bg.webp'
import bgImagePc from '../../assets/login-bonus/login_bonus_bg_pc.webp'
import slotMachine from '../../assets/login-bonus/slot_machine.webp'
import { api } from '../../utils/api-client'
import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import Modal from './modal'

const container = css`
  background-image: url(${bgImage});
  background-size: contain;
  width: 360px;
  height: 514px;
  max-width: unset;
  background-color: transparent;
  border: none;
  top: calc(50% - 30px);
  padding: 83px 46px 30px 30px;
  @media (min-width: 1200px) {
    background-image: url(${bgImagePc});
    width: 1013px;
    height: 557px;
    padding: 131px 158px 30px 236px;
  }
`

const Title = styled.h3`
  font-family: 'Syncopate-Bold';
  font-size: 12px;
  line-height: 12px;
  width: 100%;
  font-style: italic;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #f4f4f4ff;
  -webkit-text-stroke-width: 0.7px;
  -webkit-text-stroke-color: #d20c69ff;
  margin-bottom: 5px;
  @media (min-width: 1200px) {
    width: 600px;
    font-size: 28px;
    line-height: 28px;
    -webkit-text-stroke-width: 2px;
    margin: 0 auto 3px;
  }
`

const Period = styled.p`
  color: #fff;
  font-size: 12px;
  margin-bottom: 4px;
  @media (min-width: 1200px) {
    font-size: 14px;
    margin-bottom: 3px;
  }
`

const Desc = styled.p`
  color: #fff;
  font-family: 'Syncopate-Bold';
  font-size: 9px;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  height: 50px;
  margin-bottom: 16px;
  @media (min-width: 1200px) {
    font-size: 13px;
    height: 66px;
  }
`

const MachinesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  &.last {
    margin-top: 16px;
  }
  @media (min-width: 1200px) {
    &.last {
      margin-top: 0;
    }
  }
`

const Machine = styled.div`
  background-image: url(${slotMachine});
  background-size: contain;
  width: 65.14px;
  height: 57px;
  position: relative;
  .day {
    font-size: 7px;
    font-family: 'Geometr706-BlkCn-BT';
    color: #f3b115ff;
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
  }
  .block {
    width: 44px;
    height: 23px;
    border-radius: 2px;
    background: #ee8a13;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
    position: absolute;
    top: 21px;
    right: 11px;
  }
  .reward {
    position: absolute;
    top: 21px;
    right: 11px;
    width: 44px;
    height: 23px;
    text-align: center;
    padding-top: 3px;
    p {
      font-family: 'Syncopate-Bold';
      color: #000;
      font-size: 5px;
    }
    .number {
      font-size: 12px;
    }
  }
  &.last {
    width: 96px;
    height: 84px;
    .day {
      font-size: 10px;
      top: 9px;
    }
    .block {
      width: 64px;
      height: 33px;
      top: 32px;
      right: 16px;
    }
    .reward {
      width: 64px;
      height: 33px;
      top: 32px;
      right: 16px;
      p {
        font-size: 7px;
      }
      .number {
        font-size: 17px;
      }
    }
  }
  @media (min-width: 1200px) {
    width: 90.67px;
    height: 80px;
    .day {
      font-size: 10px;
      top: 9px;
    }
    .block {
      width: 60px;
      height: 33px;
      top: 30px;
      right: 15.5px;
    }
    .reward {
      width: 60px;
      height: 33px;
      top: 30px;
      right: 15.5px;
      p {
        font-size: 7px;
      }
      .number {
        font-size: 17px;
      }
    }
    &.last {
      width: 204.4px;
      height: 180px;
      .day {
        font-size: 24px;
        top: 17px;
      }
      .block {
        top: 67px;
        right: 34px;
        width: 136px;
        height: 71px;
      }
      .reward {
        top: 67px;
        right: 34px;
        width: 136px;
        height: 71px;
        padding-top: 5px;
        p {
          font-size: 15px;
        }
        .number {
          font-size: 40px;
        }
      }
    }
  }
`

const MachineOrganizer = styled.div`
  @media (min-width: 1200px) {
    padding-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 48px;
  }
`

const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 24px;
  display: flex;
  padding: 10px;
  @media (min-width: 1200px) {
    top: 30px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
`

const Here = styled.span`
  font-family: 'Avenir-Light';
  font-size: 12px;
  color: var(--txt);
  text-decoration: underline;
  display: block;
  margin: 12px auto 0;
  text-align: center;
  @media (min-width: 1200px) {
    font-size: 14px;
  }
`

interface Bonus {
  days_claimed: {
    day1?: 0 | 1
    day2?: 0 | 1
    day3?: 0 | 1
    day4?: 0 | 1
    day5?: 0 | 1
    day6?: 0 | 1
    day7?: 0 | 1
  }
}

const LoginBonus = () => {
  const { t, i18n } = useTranslation(['loginBonus', 'homeV2'])
  const { language } = i18n
  const modal = useModal()
  const [bonus, setBonus] = useState<Bonus>({
    days_claimed: {},
  })

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    const getBonus = async () => {
      try {
        const res = await api.post<Bonus>('/bonus.php', {
          type: 'daily_deposit',
        }, { signal })
        setBonus(res.data)
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
      }
    }
    getBonus()

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <Modal id="login-bonus" containerStyle={container}>
      <Close onClick={() => closeModal(modal)}>
        <Icon id="close" width={15} height={15} fill="#fff" />
      </Close>
      <Title>{t('title')}</Title>
      <Period>{t('period')}</Period>
      <Desc>{t('desc')}</Desc>
      <MachineOrganizer>
        <MachinesContainer>
          {Array.from(Array(6).keys()).map(i => (
            <Machine key={i}>
              {bonus.days_claimed[
                `day${i + 1}` as keyof Bonus['days_claimed']
              ] ? (
                <div className="reward">
                  <p className="number">5</p>
                  <p>{t('free-spins')}</p>
                </div>
              ) : (
                <div className="block" />
              )}
              <p className="day">
                {t('day')} {i + 1}
              </p>
            </Machine>
          ))}
        </MachinesContainer>
        <MachinesContainer className="last">
          <Machine className="last">
            {bonus.days_claimed.day7 ? (
              <div className="reward">
                <p className="number">25</p>
                <p>{t('free-spins')}</p>
              </div>
            ) : (
              <div className="block" />
            )}
            <p className="day">{t('day')} 7</p>
          </Machine>
        </MachinesContainer>
      </MachineOrganizer>
      <Link
        to="/promotions/$promoId"
        params={{
          promoId: language === 'en' ? '242-deposit-and-win-at-mexplay' : '241-deposita-y-gana-en-mexplay',
        }}
        onClick={() => closeModal(modal)}>
        <Here>{t('terms', { ns: 'homeV2' })}</Here>
      </Link>
    </Modal>
  )
}

export default NiceModal.create(LoginBonus)
